import Firebase from 'firebase'

// Production
// Firebase.initializeApp({
//   apiKey: 'AIzaSyCQzCt70IkPMqWpbOeq_bIJB0UXcY9PxVw',
//   authDomain: 'nonprofiterscom.firebaseapp.com',
//   databaseURL: 'https://nonprofiterscom.firebaseio.com',
//   projectId: 'nonprofiterscom',
//   storageBucket: '',
//   messagingSenderId: '164156801326'
// })

// Staging
Firebase.initializeApp({
  apiKey: 'AIzaSyA9uxzzBkiPVHr8tLWX77YbSmAGiYS_iYs',
  authDomain: 'nonprofiters-staging.firebaseapp.com',
  databaseURL: 'https://nonprofiters-staging.firebaseio.com',
  projectId: 'nonprofiters-staging',
  storageBucket: 'nonprofiters-staging.appspot.com',
  messagingSenderId: '512606812580'
})

export default Firebase



// WEBPACK FOOTER //
// ./src/service/firebase.js